import React from 'react';
import { FiEdit, FiTrash2, FiFileText } from 'react-icons/fi';

const UserTable = ({ 
  users, 
  loading, 
  error, 
  handleEditUser, 
  handleDeleteClick,
  formatDate 
}) => {
  // Helper function to determine user role display text
  const getUserRole = (user) => {
    if (!user.permissions || user.permissions.length === 0) {
      return user.isAdmin ? 'Diretoria' : 'Associado';
    }
    
    if (user.permissions.includes('Master')) {
      return 'Master';
    } else if (user.permissions.includes('Diretoria')) {
      return 'Diretoria';
    } else if (user.permissions.includes('Associado')) {
      return 'Associado';
    } else if (user.permissions.includes('Suporte')) {
      return 'Suporte';
    } else if (user.permissions.includes('Financeiro')) {
      return 'Financeiro';
    } else {
      return user.isAdmin ? 'Diretoria' : 'Associado';
    }
  };
  
  // Helper function to determine badge class
  const getRoleBadgeClass = (user) => {
    if (!user.permissions || user.permissions.length === 0) {
      return user.isAdmin ? 'diretoria' : 'Associado';
    }
    
    if (user.permissions.includes('Master')) {
      return 'master';
    } else if (user.permissions.includes('Diretoria')) {
      return 'diretoria';
    } else if (user.permissions.includes('Associado')) {
      return 'associado';
    } else if (user.permissions.includes('Financeiro')) {
      return 'financeiro';
    } else if (user.permissions.includes('Suporte')) {
      return 'suporte';
    } else {
      return user.isAdmin ? 'diretoria' : 'Associado';
    }
  };
  return (
    <div className="user-table-container" style={{ overflowX: 'auto', marginTop: '10px' }}>
      {/* Error message */}
      {error && (
        <div style={{ 
          padding: '12px', 
          backgroundColor: 'rgba(244, 67, 54, 0.1)', 
          color: '#d32f2f',
          borderRadius: '4px',
          marginBottom: '16px'
        }}>
          {error}
        </div>
      )}
      
      {/* Loading state */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '24px' }}>
          <p>Carregando usuários...</p>
        </div>
      ) : (
        <table className="users-table">
          <thead>
            <tr>
              <th>Nome de Usuário</th>
              <th>Nome Completo</th>
              <th>Email</th>
              <th>Função</th>
              <th>Data de Cadastro</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
              <td colSpan="6" style={{ textAlign: 'center', padding: '24px' }}>
              Nenhum usuário encontrado.
              </td>
              </tr>
            ) : (
              users.map(user => (
                <tr key={user._id}>
                  <td>{user.username}</td>
                  <td>{user.nomeCompleto || '-'}</td>
                  <td>{user.email}</td>
                  <td>
                    <span className={`user-role-badge ${getRoleBadgeClass(user)}`}>
                      {getUserRole(user)}
                    </span>
                  </td>
                  <td>{formatDate(user.createdAt)}</td>
                  <td>
                    <div className="action-buttons">
                      <button 
                        className="action-btn edit" 
                        onClick={() => handleEditUser(user)}
                        title="Editar"
                      >
                        <FiEdit />
                      </button>
                      <button 
                        className="action-btn delete"
                        onClick={() => handleDeleteClick(user)}
                        title="Excluir"
                      >
                        <FiTrash2 />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UserTable;